import React, { Component } from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import { Row, Col, Button, Spinner } from 'reactstrap'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Typography,
  Autocomplete,
} from '@mui/material'
import algoliasearch from 'algoliasearch'
import CoachingEntryDrawer from '../../components/Drawer/CoachingEntryDrawer'

const COLUMNS = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Nimi', width: 150, editable: false },
  { field: 'state', headerName: 'Tila', width: 150, editable: true },
  { field: 'notes', headerName: 'Muistiinpanot', width: 200, editable: false },
  { field: 'upsert', headerName: 'Päivitetty', width: 150, editable: false },
]

const algoliaclient = algoliasearch(
  '6WV1D95IXL',
  'd7e7d2238757ecd7bfd520b2b3a5562f'
)
const algoliaindex = algoliaclient.initIndex('falcon_combined')

const USER_FIELDS = [
  'id',
  'name',
  'firstname',
  'lastname',
  'email',
  'phone',
]

function AddParticipant({ entries, firebase, season, coachingclass, onSaved }) {
  const [newparticipant, setNewParticipant] = React.useState([])
  const [searchresults, setSearchResults] = React.useState([])
  const [saving, setSaving] = React.useState(false)

  console.log('AddParticipant props:', { entries, season, coachingclass })

  const clearAlgolia = (x) => {
    x.id = x.objectID
    delete x._highlightResult
    delete x.lastmodified
    delete x.reservationAlert
    delete x.objectID
    return x
  }

  const handleOptionLabel = (option) => {
    const title =
      option.firstname && option.lastname
        ? option.firstname + ' ' + option.lastname
        : ''
    return title + ' (' + option.email + ')'
  }

  const handleParticipantChange = (event, value) => {
    setNewParticipant(value)
  }

  const searchParticipants = (input) => {
    algoliaindex
      .search(input, { filters: '_tags:' + firebase.customerid })
      .then(({ hits }) => {
        const searchresults = hits
          .filter(
            (x) =>
              x.email &&
              x.email.indexOf('_reg') < 0 &&
              x.email.indexOf('_del') < 0
          )
          .map((x) => clearAlgolia(x))
        setSearchResults(searchresults)
      })
  }

  const addParticipants = async () => {
    setSaving(true)
    const formattedEntries = newparticipant.map((p) => {
      const _p = {}
      USER_FIELDS.forEach((field) => {
        _p[field] = p[field] || ''
      })
      _p.state = 'registered'
      _p.name = p.firstname + ' ' + p.lastname
      return _p
    })

    console.log('Adding participants:', season, coachingclass, formattedEntries)
    await firebase.addCoachingEntriesBatch(
      formattedEntries,
      season,
      coachingclass
    )
    if (onSaved) onSaved()
    setSaving(false)
    setNewParticipant([])
  }

  const toggleMessageDialog = (open) => {
    // Implement message dialog toggle logic here
  }

  return (
    <React.Fragment>
      <Row>
        <Col xs={12} md={4}>
          <Autocomplete
            multiple
            options={searchresults || []}
            getOptionLabel={handleOptionLabel} // {option => option.name}
            onChange={handleParticipantChange}
            isOptionEqualToValue={(option, val) => {
              return option.id === val.id
            }}
            value={newparticipant}
            onInputChange={(event, newInputValue) => {
              if (newInputValue.length > 2) {
                searchParticipants(newInputValue)
              }
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  variant='outlined'
                  label='Lisää henkilöitä'
                  placeholder='Henkilöt'
                  margin='normal'
                  // fullWidth
                />
              )
            }}
            renderOption={(optionprops, option) => {
              // MUI v5+ calls this with (props, option); see CustomerSelector for the detail.
              const { key, ...rest } = optionprops
              const title =
                option.firstname && option.lastname
                  ? option.firstname + ' ' + option.lastname
                  : ''
              return (
                <li key={key || option.id} {...rest}>
                  <div>
                    <span>{title}</span>
                    <Typography variant='body2' color='textSecondary'>
                      {option.email}
                    </Typography>
                  </div>
                </li>
              )
            }}
          />
        </Col>
        <Col xs={12} md={4}>
          <Button
            variant='contained'
            color='primary'
            disabled={entries.length === 0}
            onClick={() => {
              toggleMessageDialog(true)
            }}
          >
            Lähetä viesti valituille
          </Button>
        </Col>
      </Row>
      {newparticipant && newparticipant.length > 0 && (
        <Row>
          <Col xs={12} md={4}>
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                addParticipants()
              }}
            >
              {saving ? <Spinner size={'sm'} /> : 'Tallenna'}
            </Button>
          </Col>
        </Row>
      )}
      {/* <pre>{JSON.stringify(newparticipant, null,  )}</pre> */}
    </React.Fragment>
  )
}

class CoachingEntriesContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // state variables go here
      classes: [],
      seasons: [],
      entries: [],
      filters: {
        season: '',
        class: '',
        status: '',
      },
      columns: COLUMNS,
      loading: true,
      quering: false,
      selectionModel: [],
      selectedEntry: null,
      entryDrawerOpen: false,
      selectedApplication: null,
    }
  }

  async componentDidMount() {
    // Fetch initial data here
    const [seasons, classes, applications] = await Promise.all([
      this.props.firebase.getCoachingSeasons(),
      this.props.firebase.getCoachingClasses(),
      this.props.firebase.getCoachingApplications(),
    ])
    console.log('Fetched seasons:', seasons)
    console.log('Fetched classes:', classes)
    console.log('Fetched applications:', applications)
    this.setState({
      seasons,
      classes,
      applications,
      loading: false,
      selectedEntry: null,
      entryDrawerOpen: false,
      selectedApplication: null,
    })
  }

  getEntries = async () => {
    this.setState({ quering: true })
    // Fetch entries based on filters
    const entries = await this.props.firebase.getCoachingEntries(
      this.state.filters.season,
      this.state.filters.class
    )
    console.log('Fetched entries:', entries)
    this.setState({ entries, quering: false })
  }

  setApplication = () => {
    if(this.state.filters && this.state.filters.season && this.state.filters.class) {
      const application = this.state.applications.find(app => app.seasonid === this.state.filters.season && app.classid === this.state.filters.class)
      this.setState({ application })
    }
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>
    }
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='3'>
              {/* Filters go here  */}
              {/* <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}> */}
                <InputLabel id='style-label'>Kausi</InputLabel>
                <Select
                  fullWidth
                  value={this.state.filters.season}
                  onChange={(e) =>
                    this.setState({
                      filters: {
                        ...this.state.filters,
                        season: e.target.value,
                      },
                    }, this.setApplication)
                  }
                >
                  <MenuItem value=''>Kaikki kaudet</MenuItem>
                  {this.state.seasons.map((season) => (
                    <MenuItem key={season.id} value={season.id}>
                      {season.name}
                    </MenuItem>
                  ))}
                </Select>
              {/* </FormControl> */}
            </Col>
            <Col md='3'>
              {/* <FormControl variant='standard' sx={{ m: 1, minWidth: 120 }}> */}
                <InputLabel id='style-label'>Valmennuskokonaisuus</InputLabel>
                <Select
                  fullWidth
                  value={this.state.filters.class}
                  onChange={(e) =>
                    this.setState({
                      filters: { ...this.state.filters, class: e.target.value },
                    }, this.setApplication)
                  }
                >
                  <MenuItem value=''>Kaikki valmennuskokonaisuudet</MenuItem>
                  {this.state.classes.map((coachingClass) => (
                    <MenuItem key={coachingClass.id} value={coachingClass.id}>
                      {coachingClass.name}
                    </MenuItem>
                  ))}
                </Select>
              {/* </FormControl> */}
            </Col>
            <Col md='3' style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                color='primary'
                onClick={this.getEntries}
                disabled={
                  this.state.quering ||
                  !(this.state.filters.season && this.state.filters.class)
                }
              >
                Hae
              </Button>
            </Col>
          </Row>
          <Row style={{ marginTop: 20 }}>
            <Col md='12'>
              <AddParticipant
                entries={this.state.entries}
                firebase={this.props.firebase}
                season={this.state.filters.season}
                coachingclass={this.state.filters.class}
                onSaved={() => this.getEntries()}
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <DataGrid
                components={{ Toolbar: GridToolbar }}
                autoHeight
                rows={this.state.entries}
                columns={this.state.columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50, 100]}
                // checkboxSelection
                onSelectionModelChange={(newSelectionModel) => {
                  console.log('newSelectionModel', newSelectionModel)
                  const selectedId = newSelectionModel[0]
                  const selectedEntry = this.state.entries.find(
                    (entry) => entry.id === selectedId
                  )
                  this.setState({ selectionModel: newSelectionModel, selectedEntry, entryDrawerOpen: true })
                  
                }}
                selectionModel={this.state.selectionModel}
              />
            </Col>
          </Row>
        </div>
        <div>
          <CoachingEntryDrawer open={this.state.entryDrawerOpen} onClose={() => this.setState({ entryDrawerOpen: false })} entry={this.state.selectedEntry} application={this.state.application} />
        </div>
        <pre>{JSON.stringify(this.state.filters, null, 2)}</pre>
      </>
    )
  }
}

export default withFirebase(CoachingEntriesContainer)
